import { render, staticRenderFns } from "./PopUpPreviw.vue?vue&type=template&id=5fb54781"
import script from "./PopUpPreviw.vue?vue&type=script&lang=js"
export * from "./PopUpPreviw.vue?vue&type=script&lang=js"
import style0 from "./PopUpPreviw.vue?vue&type=style&index=0&id=5fb54781&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports